exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/* You can add global styles to this file, and also import other style files */\n.red {\n    color: red;\n}\n\n.black {\n    color: black;\n}\n\n.myTextarea{\n  font-size: 16px;\n  font-family: monospace;\n  height: 15em;\n  resize: none;\n  word-break: break-all;\n}\n\n.mio {\n\n  font-size: 20px;\n  color: green;\n\n\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// /Users/usuario/Desktop/duran/duran-web/node_modules/css-loader?{"sourceMap":false,"importLoaders":1}!/Users/usuario/Desktop/duran/duran-web/node_modules/postcss-loader?{"ident":"postcss"}!/Users/usuario/Desktop/duran/duran-web/src/styles.css
// module id = ../../../../css-loader/index.js?{"sourceMap":false,"importLoaders":1}!../../../../postcss-loader/index.js?{"ident":"postcss"}!../../../../../src/styles.css
// module chunks = styles